export const charttext = {
    id: "Identifiant",
    name: "Nom du graphique",
    source: "Source de donnée",
    type: "Type de graphique",
    granularity: "Granularité",
    notime: "Non temporel",
    params: "Paramètres du graphique",
    timechart: "Graphique temporel",
    visibility: "Visibilité du graphique",
    all: "Tous les groupes",
    distribution: "Distribution",
    distributiongroupment : "Regroupement",
    point: "Point",
    definition: "Type de donnée",
    position: "Position",
    serietype: "Type",
    seriename : "Nom",
    axis: "Axe",
    valuetype: "Type de valeur",
    rightaxis: "Axe de droite",
    leftaxisunit : "Unité axe de gauche",
    rightaxisunit : "Unité axe de droite",
    defaultoccupationschedule : "Afficher par défaut le planning d'occupation",
    typeparams: "Paramètres du type",
    lowerisbetter: "La plus petite valeur est la meilleure",
    displaytotal: "Afficher une ligne de total",
    gaugemin: "Valeur minimum",
    gaugemax: "Valeur maximum",
    gaugesegmentscount : "Nombre de segments",
    gaugesegments : "Segments",
    gaugesegmentmin: "Valeur de début",
    gaugesegmentmax: "Valeur de fin",
    gaugesegmentcolor: "Couleur",
    gaugesegmentshortname: "Etiquette",
    gaugesegmentname: "Description",
    gaugesegment : "Segment",
    decalage: "Décaler la donnée dans le temps",
    decalageunit: "Unité",
    decalageqty: "Quantité",
    changedatatimefiltering: "Filtrer la période de donnée",
    fromday:"Du",
    fromhour:"De",
    today:"Au",
    tohour:"A", 
    agregatg: "Agrégation dans le temps",
    replacebyzero: "Remplacer par zéro",
    pointgranularity: "Granularité du point utilisée",
    agregatv: "Agrégation entre les valeurs",
    indicname: "Nom",
    indicdescription: "Description",
    indicgranularity: "Granularité",
    equipment: "Equipement",
    group: "Groupe",
    realestatename : "Nom de la propriété",
    realestatedescription : "Description",
    formule: "Formule",
    formulapretty: "Formule calculée",
    color: "Couleur",
    parameters: "Paramètres",
    stack: "Empilement",
    searchingroups: "Rechercher les valeurs dans les groupes enfants",
    searchedgroup : "Type de groupes recherchés",
    unit : "Unité",
    serieagg : "Agrégation de la série (pour total ou regroupement)",
    datatype : "Type de valeur",
    selectedequipments: " équipement(s) sélectionné(s)",
    equipmentdatatype : "Type de donnée",
    equipmentcount : "Nombre d'équipements concernés",
    heatmapdisplay : "Affichage Ordonnée/Abscisse",
    heatmapcolor : "Couleur",
    day: "Jour",
    hour: "Heure",
    month: "Mois",
    tooltip: "Texte d'aide sur le graphique"
}

